import { CLERK_ADMIN_ORG_SLUG, UserSession } from './types'

// In lib so it can be used in both server and client contexts.

import { defineAbilityFor, type AppAbility } from './permissions'

export { subject, type AppAbility } from './permissions'
type MembershipInfo = { belongsToLab: boolean; belongsToEnclave: boolean }
export type UserSessionWithAbility = UserSession & { ability: AppAbility; can: AppAbility['can'] } & MembershipInfo

export const sessionFromMetadata = ({
    metadata,
    prefs: _prefs,
    clerkUserId,
}: {
    metadata: UserPublicMetadata
    prefs: UserUnsafeMetadata
    clerkUserId: string
}): UserSessionWithAbility => {
    const info = metadata as unknown as UserInfo

    if (!info || !info.format) {
        throw new Error('user does not have valid metadata')
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const orgs = info.orgs || ((info as any).teams as Record<string, UserOrgMembershipInfo>) || {}

    const isSiAdmin = Boolean(orgs[CLERK_ADMIN_ORG_SLUG]?.isAdmin)

    const session: UserSession = {
        user: {
            ...info.user,
            clerkUserId,
            isSiAdmin,
        },
        orgs,
    }
    const membershipInfo: MembershipInfo = Object.values(orgs).reduce(
        (acc: MembershipInfo, org) => {
            const mb: MembershipInfo = { ...acc }
            if (org.isAdmin || org.type === 'lab') mb.belongsToLab = true
            if (org.isAdmin || org.type === 'enclave') mb.belongsToEnclave = true
            return mb
        },
        { belongsToEnclave: session.user.isSiAdmin, belongsToLab: session.user.isSiAdmin },
    )

    const ability = defineAbilityFor(session)

    return {
        ...session,
        ...membershipInfo,
        can: ability.can.bind(ability),
        ability,
    }
}
